import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import InvoicesComp from './InvoicesComp'
import RecordPaymentComp from './RecordPaymentComp'


function RecordPayment() {
  return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Payments</h1>
                    <NavBar />
                </div>
                <RecordPaymentComp />
            </div>
        </div>
  )
}

export default RecordPayment